import { EmailActors } from './email-actors.interface';

export const initialState: EmailActors = {
  items: [],
  loading: false,
  loaded: false,
  saving: false,
  saved: false,
};
